import { render, staticRenderFns } from "./edit-lab.vue?vue&type=template&id=4497e72e&scoped=true&"
import script from "./edit-lab.vue?vue&type=script&lang=js&"
export * from "./edit-lab.vue?vue&type=script&lang=js&"
import style0 from "./edit-lab.vue?vue&type=style&index=0&id=4497e72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4497e72e",
  null
  
)

export default component.exports